"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.8 2.7a.7.7 0 0 1 .7-.7h13a.7.7 0 0 1 .7.7v13.99c0 .823-.865 1.357-1.6.99l-1.267-.635-1.671.837-.002.001a1.106 1.106 0 0 1-.987 0h-.001L10 17.045l-1.671.837-.002.001a1.106 1.106 0 0 1-.987 0h-.002l-1.671-.838-1.265.634h-.003a1.107 1.107 0 0 1-1.599-.99V2.7Zm1.4.7v12.815l1.153-.578a.7.7 0 0 1 .628 0l1.853.928 1.853-.928a.7.7 0 0 1 .626 0l1.853.927 1.854-.928a.7.7 0 0 1 .627 0l1.153.578V3.4H4.2Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.056 5.572a.7.7 0 0 1 .7.7v.088c.454.114.811.34 1.072.64.36.413.483.905.483 1.262a.7.7 0 0 1-1.4 0 .572.572 0 0 0-.139-.342c-.084-.097-.271-.242-.716-.242-.374 0-.583.111-.692.212a.5.5 0 0 0-.164.372c0 .103.026.194.17.33.171.162.472.346.975.574.518.236 1 .482 1.35.803.392.358.616.808.616 1.376 0 .6-.26 1.119-.696 1.474a2.23 2.23 0 0 1-.86.425v.092a.7.7 0 1 1-1.4 0v-.102C6.367 12.951 5.8 12.09 5.8 11.345a.7.7 0 1 1 1.4 0c0 .121.2.585.856.585.325 0 .547-.093.675-.196a.471.471 0 0 0 .18-.389c0-.142-.035-.228-.162-.344-.169-.155-.464-.324-.983-.56-.534-.242-1.01-.504-1.358-.832-.375-.354-.608-.797-.608-1.347a1.9 1.9 0 0 1 .614-1.4c.256-.237.576-.407.942-.5v-.09a.7.7 0 0 1 .7-.7Zm3.189 1.485a.7.7 0 0 1 .7-.7H13.5a.7.7 0 1 1 0 1.4h-1.556a.7.7 0 0 1-.7-.7Zm0 2.747a.7.7 0 0 1 .7-.7H13.5a.7.7 0 1 1 0 1.4h-1.556a.7.7 0 0 1-.7-.7Zm0 2.747a.7.7 0 0 1 .7-.7H13.5a.7.7 0 1 1 0 1.4h-1.556a.7.7 0 0 1-.7-.7Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ReceiptIcon20.js.map